import { render, staticRenderFns } from "./Magiclink.vue?vue&type=template&id=d20ff9ee&"
import script from "./Magiclink.vue?vue&type=script&lang=js&"
export * from "./Magiclink.vue?vue&type=script&lang=js&"
import style0 from "./Magiclink.vue?vue&type=style&index=0&id=d20ff9ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports